import { RandomGenerator } from '../../../test-utils';
var MailboxSettingsBuilder = /** @class */ (function () {
    function MailboxSettingsBuilder() {
        this.mailboxSettings = {
            forwardingAddress: { email: 'test@forwarding.com', name: 'fwdTest' },
            signingDomain: 'testSigninDomain',
            trackingDomain: 'testTrackingDomain'
        };
    }
    MailboxSettingsBuilder.prototype.withForwardingAddress = function (email, name) {
        this.mailboxSettings.forwardingAddress.email = email;
        this.mailboxSettings.forwardingAddress.name = name;
        return this;
    };
    MailboxSettingsBuilder.prototype.withSignInDomain = function (domain) {
        this.mailboxSettings.signingDomain = domain;
        return this;
    };
    MailboxSettingsBuilder.prototype.withTrackingDomain = function (domain) {
        this.mailboxSettings.trackingDomain = domain;
        return this;
    };
    MailboxSettingsBuilder.prototype.build = function () {
        return this.mailboxSettings;
    };
    return MailboxSettingsBuilder;
}());
export { MailboxSettingsBuilder };
var MailboxBuilder = /** @class */ (function () {
    function MailboxBuilder() {
        this.mailbox = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            email: 'test@test.com',
            default: false,
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            context: 'testContext',
            name: 'testName',
            mailboxSettings: new MailboxSettingsBuilder().build(),
            brandId: RandomGenerator.id()
        };
    }
    MailboxBuilder.prototype.withId = function (id) {
        this.mailbox.id = id;
        return this;
    };
    MailboxBuilder.prototype.withEmail = function (email) {
        this.mailbox.email = email;
        return this;
    };
    MailboxBuilder.prototype.withDefaultSetting = function (isDefault) {
        this.mailbox.default = isDefault;
        return this;
    };
    MailboxBuilder.prototype.withCreationDate = function (date) {
        this.mailbox.creationDate = date;
        return this;
    };
    MailboxBuilder.prototype.withLastUpdateDate = function (date) {
        this.mailbox.lastUpdateDate = date;
        return this;
    };
    MailboxBuilder.prototype.withContext = function (context) {
        this.mailbox.context = context;
        return this;
    };
    MailboxBuilder.prototype.withName = function (name) {
        this.mailbox.name = name;
        return this;
    };
    MailboxBuilder.prototype.withMailboxSettings = function (mailboxSettings) {
        this.mailbox.mailboxSettings = mailboxSettings;
        return this;
    };
    MailboxBuilder.prototype.withBrandId = function (brandId) {
        this.mailbox.brandId = brandId;
        return this;
    };
    MailboxBuilder.prototype.build = function () {
        return this.mailbox;
    };
    return MailboxBuilder;
}());
export { MailboxBuilder };
;
//# sourceMappingURL=mailbox-builder.js.map